import React, { Fragment } from "react";
import "./styles.scss";
import { XCircle, X, CheckCircle } from "react-feather";

const FeedbackMessage = (
  { level = "error", message, onDismiss, style },
  ref
) => {
  const formattedMessage =
    message && typeof message === "string"
      ? message.split("\n").map((msg, i) => (
          <Fragment key={i}>
            {i > 0 && <br />}
            {msg}
          </Fragment>
        ))
      : message;

  return (
    <div className={"error-message " + level} style={style} ref={ref}>
      {level === "error" && (
        <XCircle data-testid="error-icon" className="icon" />
      )}
      {level === "success" && (
        <CheckCircle data-testid="success-icon" className="icon" />
      )}
      <div className="description">
        {!!formattedMessage && formattedMessage}
      </div>
      {onDismiss && (
        <X
          data-testid="dismiss-button"
          className="dismiss-button"
          onClick={onDismiss}
        />
      )}
    </div>
  );
};

export default React.forwardRef(FeedbackMessage);
